<app-page-title [title]="'Biometric Consent'"></app-page-title>
<app-biometric-consent-form (setBiometricConsent)="goNext($event)"></app-biometric-consent-form>
